/** Portal target for app-wide fixed chrome (order bar, captain FAB, etc.). */
export function getFixedChromePortalTarget(): HTMLElement {
  return document.getElementById('peppar-fixed-chrome') ?? document.body;
}
